import {PartOfTheDay} from '@nursio-link/common';
import dayjs from 'dayjs';
import {groupBy, prop} from 'ramda';

import type {DosageDetails, ResidentMedication} from '@/services/graphqlHooks';
import {TimeType} from '@/services/graphqlHooks';
import {getPartOfTheDayFromTimestamp} from '@/shared/tasks/utils/getForecastedTasks';

export type DosageDetailsWithPartOfTheDay = DosageDetails & {
  timeOfDay: PartOfTheDay;
};

export type MedicationWithPartOfTheDay = ResidentMedication & {
  [PartOfTheDay.MORNING]: DosageDetails[];
  [PartOfTheDay.AFTERNOON]: DosageDetails[];
  [PartOfTheDay.EVENING]: DosageDetails[];
  [PartOfTheDay.NIGHT]: DosageDetails[];
};

const getTimestampFromTime = (time: string): number => {
  const [hours, minutes] = time.split(':').map(Number);
  return dayjs().hour(hours).minute(minutes).second(0).valueOf();
};

export const getMedicationWithPartOfTheDay = (
  residentMedication: ResidentMedication[]
): MedicationWithPartOfTheDay[] =>
  residentMedication.map(medication => {
    const {schedule} = medication || {};

    const dosageWithPartOfTheDay = schedule?.dosageDetails?.map(dosage => {
      return {
        ...dosage,
        timeOfDay:
          dosage?.timeType === TimeType.Specific
            ? getPartOfTheDayFromTimestamp(getTimestampFromTime(dosage.time!))
            : dosage?.timeOfDay,
      };
    }) as DosageDetailsWithPartOfTheDay[];

    const dosageByPartOfTheDay = groupBy(
      prop('timeOfDay'),
      dosageWithPartOfTheDay || []
    ) as Record<PartOfTheDay, DosageDetailsWithPartOfTheDay[]>;

    return {
      ...medication,
      [PartOfTheDay.MORNING]: dosageByPartOfTheDay[PartOfTheDay.MORNING] || [],
      [PartOfTheDay.AFTERNOON]:
        dosageByPartOfTheDay[PartOfTheDay.AFTERNOON] || [],
      [PartOfTheDay.EVENING]: dosageByPartOfTheDay[PartOfTheDay.EVENING] || [],
      [PartOfTheDay.NIGHT]: dosageByPartOfTheDay[PartOfTheDay.NIGHT] || [],
    };
  });
